module.exports = __webpack_public_path__ + "media/images/main/k5-21a7919b4f7c5a65f398f72e5782e517.jpg";